import React from 'react'
import './ServiceCard.css'

const ServiceCard = ({ service, detailed = false }) => {
  return (
    <article className={`service-card${detailed ? ' service-card--detailed' : ''}`}>
      <div className="service-card__icon">{service.icon}</div>
      <h3 className="service-card__title">{service.title}</h3>
      <p className="service-card__blurb">{service.blurb}</p>
      {detailed && service.detail && (
        <p className="service-card__detail">{service.detail}</p>
      )}
    </article>
  )
}

export default ServiceCard
